export const LS_USER_SUBSCRIPTIONS = 'user-subscriptions'
export const LS_ACCESSTOKEN = 'access-tokens'
export const LS_USER = 'user'
export const LS_RATINGS = 'ratings'
export const LS_SUBSCRIPTIONS = 'subscriptions'
export const LS_LOCAL_MODS = 'local-mods'
export const LS_ACTIVATIONS = 'activations'
export const LS_REDIRECT = 'redirect'
export const LS_COOKIE = 'cookies'
export const LS_KARMA = 'karma'
export const LS_TEAMS = 'teams'
